export class UnauthorizedException extends Error {
  public readonly statusCode: number = 401;
}
